export const getFullName = (firstName, lastName) => {
  const fn = firstName ?? '';
  const ln = lastName ?? '';

  return fn || ln ? `${fn} ${ln}` : '-';
};
